module.exports = __webpack_public_path__ + "img/loading.8f7f098c.gif";